export default function Button({ children, onClick, type = "button" }) {
    return (
        <button type={type ?? "button"} onClick={onClick} className="px-4 py-2 border rounded-xl">
            {children}
        </button>
    )
}